/**
 * Created by andrey on 19.01.2021.
 */

const MergeTutorialView = cc.Node.extend({
    ctor: function (tutorial) {
        this._super();

        this.tutorial = tutorial;

        const sceneSize = cleverapps.resolution.getSceneSize();
        this.setContentSize2(sceneSize);
        this.setAnchorPoint(0.5, 0.5);
        this.setLocalZOrder(12);
        this.setCascadeOpacityEnabled(true);

        this.tutorial.on("showTutorialStep", this.showTutorialStep.bind(this), this);
        this.tutorial.on("finishTutorialStep", this.finishTutorialStep.bind(this), this);
        this.tutorial.on("showUpWindow", this.onWindowToggle.bind(this, true), this);
        this.tutorial.on("closeWindows", this.onWindowToggle.bind(this, false), this);

        cleverapps.eventBus.on("openInfoView", this.onInfoViewToggle.bind(this, true), this);
        cleverapps.eventBus.on("closeInfoView", this.onInfoViewToggle.bind(this, false), this);
    },

    showTutorialStep: function (data, move) {
        this.stopAllActions();
        this.removeDialogue();

        this.data = data;
        this.move = move;

        if (this.data.type === Map2d.CLOSE_WINDOWS) {
            this.tutorialWindow = cleverapps.focusManager.currentWindow();
        }

        this.scrollToTargetAndCreateDialogue();
    },

    scrollToTargetAndCreateDialogue: function () {
        if (!this.move || !this.data) {
            return;
        }

        let delta, target, scrollAction;

        if (this.move.cells && !this.data.noScroll) {
            const scroll = Map2dScroller.currentScroller.getScrollView();
            const mapView = Map2d.currentMap.getMapView();
            const options = { allowScrollWithFocus: true };

            if (this.move.mergeCluster) {
                const targetCells = this.move.mergeCluster.map((cell) => mapView.getCell(cell.x, cell.y));
                target = cc.getCenter(targetCells);
                scrollAction = new cc.ScrollAction(target, options);
                const targetPos = scroll.normalizePoint(scroll.outOfBoundariesVector(cc.p(target)));
                const startPos = scroll.getContainerPosition();
                delta = cc.pSub(targetPos, startPos);
            } else {
                options.visibleBox = {
                    left: 0.3, right: 0.4, top: 0.15, bottom: 0.1
                };
                const targetCell = this.move.cells[0];
                target = mapView.getCell(targetCell.x, targetCell.y);
                scrollAction = new cc.CellScrollAction(targetCell, options);
                delta = scrollAction.calcNodeDelta(scroll, target, options);
            }

            delta.x *= scroll.zoom;
            delta.y *= scroll.zoom;
            scroll.runAction(new cc.Sequence(
                new cc.DelayTime(0.01),
                scrollAction.easing(cc.easeInOut(2))
            ));
        }

        const infoTarget = this.data.lovesInfoView && Map2d.currentMap.getUnit(this.move.cells[0].x, this.move.cells[0].y);
        if (infoTarget && !InfoView.IsDisplayedFor(infoTarget)) {
            InfoView.DisplayInfo(infoTarget);
        } else if (this.dialogueComponent) {
            this.dialogueComponent.updateTargets(this.listRects(this.move, delta));
        } else {
            this.createDialogue(delta);
        }
    },

    finishTutorialStep: function () {
        this.data = undefined;
        this.move = undefined;

        if (this.tutorialWindow) {
            this.tutorialWindow = undefined;
        }

        this.removeDialogue();
    },

    createDialogueContent: function (text) {
        if (!Array.isArray(text)) {
            return Messages.get(text);
        }

        text = text.map((item) => {
            if (item.code !== undefined && item.stage !== undefined) {
                const icon = UnitView.getUnitImage(item, { alignAnchorX: true, preferStatic: true });
                icon.setScale(1.5);
                return icon;
            }
            return item;
        });

        const maxIconHeight = cleverapps.UI.generateOnlyText("12345", cleverapps.styles.FONTS.FORCE_MESSAGE_TEXT).height * 2;

        const messages = text.map((message) => {
            if (typeof message === "string") {
                return cleverapps.UI.generateOnlyText(Messages.get(message), cleverapps.styles.FONTS.FORCE_MESSAGE_TEXT);
            }
            cleverapps.UI.fitToBox(message, {
                maxScale: message.scale,
                height: maxIconHeight
            });
            return message;
        });

        return new cleverapps.Layout(messages, {
            direction: cleverapps.UI.HORIZONTAL,
            margin: cleverapps.styles.MergeTutorialView.margin
        });
    },

    listRects: function (move, delta) {
        const rects = Map2dAdviceView.listRects(this.data, { move, delta });

        if (this.tutorialWindow && this.tutorialWindow.window) {
            rects.push(this.tutorialWindow.window.getBoundingBox());
        }

        return rects;
    },

    createDialogue: function (delta) {
        if (!this.data || !this.data.text || this.dialogueComponent) {
            return;
        }

        const window = cleverapps.focusManager.currentWindow();
        const windowComponent = window && ComponentMap.get(window, WindowComponent);
        if (window && (!windowComponent.isWindowLoaded() || window !== this.tutorialWindow)) {
            return;
        }
        const params = {
            items: [this.createDialogueContent(this.data.text)],
            person: typeof this.data.person === "function" && this.data.targets ? this.data.person(this.data.targets[0]) : this.data.person,
            rects: this.listRects(this.move, delta),
            gravitate: this.data.gravitate
        };

        this.dialogueComponent = new MinimalDialogue(params);
        this.addChild(this.dialogueComponent);
        this.dialogueComponent.display();

        if (this.data.dialogueDuration) {
            this.runAction(new cc.Sequence(
                new cc.DelayTime(this.data.dialogueDuration / 1000),
                new cc.CallFunc(this.finishTutorialStep.bind(this))
            ));
        }
    },

    removeDialogue: function (silent) {
        if (this.createDialogeTimeout) {
            clearTimeout(this.createDialogeTimeout);
            delete this.createDialogeTimeout;
        }

        this.stopAllActions();

        if (this.dialogueComponent) {
            this.dialogueComponent.remove(undefined, silent);
            this.dialogueComponent = undefined;
        }
    },

    onAfterResize: function () {
        if (this.data && this.move) {
            this.scrollToTargetAndCreateDialogue();
        }
    },

    onWindowToggle: function (isOpen) {
        const window = cleverapps.focusManager.currentWindow();
        const windowComponent = window && ComponentMap.get(window, WindowComponent);
        if (isOpen && window && (!windowComponent.isWindowLoaded() || window !== this.tutorialWindow)) {
            this.removeDialogue();
        } else if (!this.tutorial.stepFinished) {
            this.scrollToTargetAndCreateDialogue();
        }
    },

    onInfoViewToggle: function (isOpen) {
        if (this.data && this.data.lovesInfoView) {
            isOpen ? this.showTutorialStep(this.data, this.move) : this.removeDialogue();
            return;
        }

        if (isOpen) {
            this.removeDialogue();
        } else {
            this.createDialogeTimeout = new cleverapps.LongTimeout(this.createDialogue.bind(this), this.data && this.data.waitAfter || 500);
        }
    }
});

cleverapps.styles.MergeTutorialView = {
    margin: 10,

    loginBtn: {
        x: { align: "right", dx: -40 },
        y: { align: "top", dy: -30 }
    }
};
